import { NavLink } from 'react-router-dom';
import './NavItem.scss';

export default function NavItem(props: any) {
	const activeClass = 'Nav__item--active';
	
	return (
		<NavLink to={props?.link} className={({ isActive }) => isActive ? activeClass : 'Nav__item'} onClick={(e) => { e.stopPropagation(); window.location.href = props?.link; }}>
			<div className='Nav__item-container'>
				<div className='Nav__item-logo'>
					{props?.icon}
				</div>
				<div className='Nav__item-text'>
					{props?.name}
				</div>
			</div>
		</NavLink>
	);
}